// TODO(omegdadi): Remove when variant is pulled from media
export const DEFAULT_CHUNK_VARIANT = {
  chunkSize: 150,
  keyframeInterval: 30,
};

export const DEFAULT_MAX_FETCH_FRAMES_REQUESTS = 10;

export const VIDEO_TRANSFORM_TYPE = {
  CHUNK: 'chunk',
  TRANSCODE: 'transcode',
};

export const MEDIA_SOURCES = {
  EPISODE_CREATION_UPLOAD: 'EPISODE_CREATION_UPLOAD',
  GETTY: 'GETTY',
  SCRAPER: 'SCRAPER',
  STORY_KIT: 'STORY_KIT',
  STORY_KIT_OUR_STORIES: 'STORY_KIT_OUR_STORIES',
  UNKNOWN: 'UNKNOWN',
  UPLOAD: 'UPLOAD',
};

export const MEDIA_AUDIO_STATUSES = {
  NOT_PROCESSED: 'NOT_PROCESSED',
  PROCESSING_COMPLETE_HAS_AUDIO: 'PROCESSING_COMPLETE_HAS_AUDIO',
  PROCESSING_COMPLETE_NO_AUDIO: 'PROCESSING_COMPLETE_NO_AUDIO',
};

export const VALID_MEDIA_SOURCES = new Set(Object.keys(MEDIA_SOURCES));
